export default "__VITE_ASSET__B5dYxV6d__"